import { Component } from '@angular/core';

@Component({
  selector: 'app-spice-of-europe-logo',
  templateUrl: './spice-of-europe-logo.component.html',
  styleUrls: ['./spice-of-europe-logo.component.scss'],
})
export class SpiceOfEuropeLogoComponent {}
